import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentHandoutComponent } from './component/supplementary-equipment-handout.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule, ServiceResponseModule, TransportInfoPanelModule } from '@sdbn/appclient';

@NgModule({
  declarations: [SupplementaryEquipmentHandoutComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
   exports: [SupplementaryEquipmentHandoutComponent]
})
export class SupplementaryEquipmentHandoutModule { }
